import { addEdge, Connection } from "@xyflow/react";
import { atom } from "jotai";

import { edgesAtom } from "./edgesAtom";
import { MARKER } from "../constants";
import { uuid } from "../utils";
import { saveCanvasSetter } from "../persistence";

export const addEdgeSetter = atom(null, (get, set, connection: Connection) => {
  const edges = get(edgesAtom);
  const id = uuid();

  const updatedEdges = addEdge(
    {
      ...connection,
      id,
      markerEnd: MARKER,
    },
    edges,
  );
  set(edgesAtom, updatedEdges);
  set(saveCanvasSetter, { edges: updatedEdges });
});

addEdgeSetter.debugLabel = "addEdgeSetter";
